module.exports = __webpack_public_path__ + "assets/img/Brighten-Home-Loans-Website-w720.80732fe5.webp";